import React from 'react';
import { compose } from 'recompose';
import { connectUserHeaderinfo } from '../Auth/WithUserHeaderInfo';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';

const PromotionGroupDiscountDesc = (props) => {
  const {
    promotions,
    userHeaderInfo: {
      isSubscriber = false,
    },
    store: {
      has_active_subscriptions = false,
    },
    passLogo = null,
  } = props;
  let discountPercentage = 0;
  promotions.some((promotion) => {
    discountPercentage = promotion.price.additionalDiscountPercentage || 0;
    return discountPercentage !== 0;
  });

  if (!has_active_subscriptions) {
    return null;
  }

  return discountPercentage === 0
    ? null
    : (<SubscriberPromotionInfo discountPercentage={discountPercentage} passLogo={passLogo} />);
};

const PBPass = (passLogo) => (
  passLogo ?
    <img src={passLogo}
      height="18px"
      className="mb-1" />
    : 'Photobook Pass'
);

const SubscriberPromotionInfo = ({ discountPercentage, passLogo }) => (
  <div>As a {PBPass(passLogo)} subscriber, you are entitled to an additional <span
    className='promotion-group__pricing--additional-discount'>{discountPercentage}%
    OFF</span>.</div>
);

const enhance = compose(
  connectUserHeaderinfo,
  withStoreDetail,
);

export default enhance(PromotionGroupDiscountDesc);



// WEBPACK FOOTER //
// ./src/Promotion/PromotionGroupDiscountDesc.js